import styled from 'styled-components'
import { BREAKPOINTS } from 'styles/constants'

export const Wrapper = styled.div`
  position: relative;
`

export const Dragzone = styled.div`
  height: 64px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--t-td-section-color);
  border: 1px dashed var(--t-td-file-uploader-dragzone-border);
  border-radius: 6px;

  svg {
    margin-right: 10px;
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    padding: 10px;
    font-size: 12px;
  }
`

export const FileList = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 20px;

  &:empty {
    display: none;
  }
`

export const FileCard = styled.a`
  // width: calc(100% / 4 - 15px);
  height: 160px;
  font-size: 12px;
  color: var(--p-neutral-520);
  background: var(--t-surface-block);
  border: 1px solid var(--t-surface-2);
  padding: 15px;
  margin: 0 20px 20px 0;
  position: relative;
  border-radius: 4px;
  transition: 300ms ease-out;

  &:nth-child(n + 4) {
    margin-right: 0;
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    width: calc(100% / 2 - 10px);

    &:nth-child(even) {
      margin-right: 0px;
    }
  }
`

export const FileDelete = styled.button`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: 5px;
  right: 5px;
  color: var(--p-neutral-550);
  background: transparent;
  cursor: pointer;
  transition: 0.3s ease-out;

  &:hover {
    color: var(--p-pink-480);
  }
`

export const FileWatch = styled.a`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: 0;
  right: 0;
  fill: var(--p-neutral-550);
  background: transparent;
  cursor: pointer;
  transition: 0.3s ease-out;

  &:hover {
    fill: var(--p-pink-480);
  }

  svg {
    width: 17px;
    height: 17px;
  }
`

export const FileActionsContainer = styled.div`
  width: 100px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: end;
  position: absolute;
  top: 0;
  right: 0;
`

export const FileImage = styled.div`
  height: 75px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

export const FileIconWrap = styled.div`
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  background: var(--t-surface-1);
  border-radius: 8px;
`

export const FileIcon = styled.svg`
  width: 53px;
  height: 67px;
  display: block;
  color: var(--t-surface-2);
`

export const FileInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`

export const FileTitle = styled.div`
  width: 100%;
  color: var(--t-link-color);
  white-space: nowrap;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 5px;
`

export const FileDate = styled.div``
